import React from 'react';
import { MyWallet } from "be-components"
import { Modal } from "react-native";
import { View } from '../../../src/Components/Themed';
import type { ItemOrderProps, MyPlayerProps, PlayerBalanceProps } from '../../../src/types';

type WalletHolderProps = {
    me:MyPlayerProps,
    my_balance?:PlayerBalanceProps,
    visible:boolean,
    insets: { top:number, bottom:number, left:number, right:number },
    mode: 'desktop'|'mobile',
    onTransact: (item_order:ItemOrderProps, account_id?:string) => void,
    onClose: () => void,
}

const WalletHolder = ({ mode, my_balance, visible, insets, onClose, onTransact }:WalletHolderProps) => {

    return (
        <Modal
            style={{flex:1}}
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            visible={visible}
            transparent
        >
            <View type='blur' style={mode=='desktop' ?{ flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1 }}>
                <View float style={mode=='desktop' ?{ flex:1, width:500, maxHeight:750, marginTop:insets.top, marginBottom:insets.bottom, borderRadius:22 }:{ flex:1, marginTop:10 + insets.top, marginBottom:10+insets.bottom, marginLeft:10+insets.left, marginRight:10+insets.right }}>
                    <MyWallet
                        new_balance={my_balance}
                        view_mode={mode}
                        header_style={{ borderRadius:8 }}
                        onEvent={(event) => console.log(event)}
                        onClose={() => onClose()}
                        onTransact={onTransact}
                    />
                </View>
            </View>

        </Modal>
    )
}

export default WalletHolder